/* RESPONSIBLE TEAM: team-knowledge-foundations */
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';
import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';

export default class Banner extends EmbercomBaseSerializer.extend(EmbeddedRecordsMixin) {
  attrs = {
    settings: { embedded: 'always' },
    appId: { serialize: false },
    helpCenterSiteId: { serialize: false },
  };

  serialize(snapshot: any, options: any) {
    let json = super.serialize(snapshot, options);

    // Convert string ID to integer for backend compatibility
    if (json.id) {
      json.id = parseInt(json.id, 10);
    }

    // Convert existing setting IDs to integers, leave new settings without IDs
    if (json.settings) {
      json.settings.forEach((setting: any) => {
        if (setting.id) {
          setting.id = parseInt(setting.id, 10);
        }
      });
    }

    return json;
  }
}
